import React from 'react';
import { connect } from 'react-redux';
import { colors, CancelIcon } from '@chegg-ui/theme';
import { IconButton } from '@chegg-ui/button';
import { ErrorContainer, ErrorText, ErrorCloseContainer, ImportantIcon } from '../styles';
import { ERROR_FILETYPE_COPY, ERROR_MAX_COPY, ERROR_DEFAULT_COPY } from '../constants';
import { closeErrorMessage } from '../actions/upload';
var ERROR_CLOSE_TEST_ID = "errorClose";
export var ErrorMessages = function ErrorMessages(_ref) {
  var alertFileSize = _ref.alertFileSize,
    alertFileType = _ref.alertFileType,
    uploadError = _ref.uploadError,
    dismiss = _ref.dismiss;
  var ref = React.useRef(null);
  var error = alertFileType || alertFileSize || uploadError;
  React.useEffect(function () {
    if (error) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
    }
  }, [error]);
  if (!error) {
    return null;
  }
  var msg = '';
  if (alertFileType) {
    msg = ERROR_FILETYPE_COPY;
  } else if (alertFileSize) {
    msg = ERROR_MAX_COPY;
  } else if (uploadError) {
    msg = ERROR_DEFAULT_COPY;
  }
  return /*#__PURE__*/React.createElement(ErrorContainer, {
    ref: ref,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(ImportantIcon, null), /*#__PURE__*/React.createElement(ErrorText, null, msg), /*#__PURE__*/React.createElement(ErrorCloseContainer, null, /*#__PURE__*/React.createElement(IconButton, {
    screenReaderOnlyText: "close error",
    onClick: dismiss
  }, /*#__PURE__*/React.createElement(CancelIcon, {
    color: colors.dark,
    size: "xsmall",
    "data-test-id": ERROR_CLOSE_TEST_ID
  }))));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    uploadError: state.upload.error,
    alertFileSize: state.ui.alertFileSize,
    alertFileType: state.ui.alertFileType
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dismiss: function dismiss() {
      dispatch(closeErrorMessage());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ErrorMessages);